import api from '@/core/services/api';
import { toDrupalRequest } from '@/core/helpers';

export default {
    async getFundFocus({ state, commit }) {
        if (state.hasLoadedFundFocus || state.isLoadingFundFocus) {
            return; // Prevent duplicate or concurrent requests
        }

        commit('setIsLoadingFundFocus', true);

        try {
            const endpoint = '/news';
            const response = await api.get(`${toDrupalRequest(endpoint)}`);

            const readEndpoint = '/news/read';
            const readArticlesResponse = await api.get(`${toDrupalRequest(readEndpoint)}`);
            commit('setReadArticles', readArticlesResponse);

            const reminderArticles = [];

            let focusFound = 0;
            let marketCommentaryFound = 0;
            let buylistUpdateFound = 0;
            let marketOverviewFound = 0;
            response.every((elm) => {
                const title = elm.title.toLowerCase();
                if (title.includes('fund focus') && focusFound === 0) {
                    if (isLessThanOneMonthAgo(elm['date_published']) && !readArticlesResponse.includes(elm.id)) {
                        reminderArticles.push(elm);
                    }
                    const linkStart = elm.body.indexOf('https://');
                    const linkEnd = elm.body.indexOf('.pdf') + 4;
                    const link = elm.body.slice(linkStart, linkEnd);
                    commit('setFundFocus', link);
                    focusFound++;
                }
                if (
                    (title.includes('market summary') ||
                        title.includes('market commentary') ||
                        title.includes('market update')) &&
                    marketCommentaryFound === 0
                ) {
                    if (isLessThanOneMonthAgo(elm['date_published']) && !readArticlesResponse.includes(elm.id)) {
                        reminderArticles.push(elm);
                    }
                    commit('setMarketCommentary', '/research/news?id=' + elm.id);
                    marketCommentaryFound++;
                }
                if (title.includes('buy list update') && buylistUpdateFound === 0) {
                    if (isLessThanOneMonthAgo(elm['date_published']) && !readArticlesResponse.includes(elm.id)) {
                        reminderArticles.push(elm);
                    }
                    buylistUpdateFound++;
                }
                if (title.includes('market overview') && marketOverviewFound === 0) {
                    if (isLessThanOneMonthAgo(elm['date_published']) && !readArticlesResponse.includes(elm.id)) {
                        reminderArticles.push(elm);
                    }
                    marketOverviewFound++;
                }
                if (focusFound && marketCommentaryFound && buylistUpdateFound && marketOverviewFound) {
                    return false;
                } else {
                    return true;
                }
            });
            commit('setResearchReminders', reminderArticles);
            commit('setHasLoadedFundFocus', true);
        } catch (error) {
            console.error('Error loading fund focus:', error);
        } finally {
            commit('setIsLoadingFundFocus', false);
        }
    },
    async markArticleRead({ commit }, { article, action }) {
        // we need to make a call to the back end to mark this article ad read or seen.
        await api.post(`${toDrupalRequest('/news/read')}`, JSON.stringify({ article_id: article.id, action: action }), {
            headers: { 'Content-Type': 'application/json' },
        });
        commit('removeArticleReminder', article);
    },
};

function isLessThanOneMonthAgo(dateStr) {
    const inputDate = new Date(dateStr.replace(' ', 'T')); // convert to ISO format
    const now = new Date();

    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(now.getMonth() - 1);

    const cutoffDate = new Date('2025-06-02T00:00:00');

    return inputDate > oneMonthAgo && inputDate > cutoffDate;
}
